// global shared items
require('./shared')

require('../site_scripts/mtc_vue_import')

require('./shared_functions')

// core plugins needed for page
require('../../../../core/js/plugins/mtc_cookies')
require('../../../../core/js/plugins/mtc_jquery.waypoints');
require('../../../../core/js/plugins/mtc_waypoints');

require('../site_scripts/mtc_opening_times_toggle');
require('../site_scripts/mtc_html5_geolocation');
require('../site_scripts/mtc_load_google_maps_on_demand');
require('../site_scripts/mtc_new_dealership_map');
require('../site_scripts/mtc_dealership_map_functions');
require('../site_scripts/mtc_directions_map');
require('../site_scripts/mtc_read_more');
require('../site_scripts/mtc_in_viewport');
require('../site_scripts/mtc_print_popup');
require('../site_scripts/mtc_print_directions');
require('../site_scripts/mtc_wrap_last_word');
require('../site_scripts/mtc_wrap_first_word');
require('../site_scripts/mtc_carz_mobile_menu');
require('../site_scripts/mtc_carz_footer_menu_trigger');
require('../site_scripts/mtc_accordions');
require('../site_scripts/mtc_sticky_franchise_header')

// functions for old header
require('../site_scripts/mtc_legacy_desktop_menu');
require('../site_scripts/mtc_legacy_mobile_menu');
require('../../../../modules/Search/js/mtc_search');
require('../site_scripts/mtc_show_hide_opening_times');
require('../site_scripts/mtc_maps_tabs');

// carstore / heritage
require('../site_scripts/mtc_slide_out_menu');

// PAP
require('../pap/flyout-menu')

// dealerships specific styles
require('../../css/dealership.less')

// dealership specific js
$(document).ready(function () {
    const openGoogleMaps = $(".js_showMapDetails");

    if (openGoogleMaps.length > 0) {
        openGoogleMaps.click();
    }
})
